// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"CustomersTestimonials_testimonials__37Jjs"};